export const MIN_OVERPAYMENT_THRESHOLD_USD = 1.0;

export const isOverpaymentAboveThreshold = (
  requiredAmountUSD: number,
  paidAmountUSD: number,
  thresholdUSD: number = MIN_OVERPAYMENT_THRESHOLD_USD,
): boolean => {
  return paidAmountUSD - requiredAmountUSD > thresholdUSD;
};
